import { defineComponent as r, createElementBlock as e, openBlock as s, createElementVNode as n, createCommentVNode as o, toDisplayString as a } from "vue";
const d = {
  class: "stash-card-header tw-px-6 tw-font-medium tw-text-ice-900",
  "data-test": "stash-card-header"
}, i = { class: "tw-text-base" }, l = {
  key: 0,
  class: "tw-mb-0 tw-mt-1.5"
}, m = {
  key: 1,
  class: "tw-mt-1.5 tw-text-ice-700"
}, u = /* @__PURE__ */ r({
  __name: "CardHeader",
  props: {
    title: {},
    subtitle: {},
    text: {}
  },
  setup(c) {
    const t = c;
    return (_, p) => (s(), e("header", d, [
      n("h4", i, a(t.title), 1),
      t.subtitle ? (s(), e("p", l, a(t.subtitle), 1)) : o("", !0),
      t.text ? (s(), e("span", m, a(t.text), 1)) : o("", !0)
    ]));
  }
});
export {
  u as default
};
//# sourceMappingURL=CardHeader.js.map
